import { HugeiconsIcon } from "@hugeicons/react";
import {
  Call02Icon,
  SmartPhone01Icon
} from "@hugeicons-pro/core-stroke-rounded";
import { Avatar } from "shared/components/Avatar";
import { cx } from "shared/utils";

interface AddressChipProps {
  address: string;
  name?: string;
  /** Chips inside an outgoing bubble take the design's pink ground. */
  tinted?: boolean;
  /** A business line (the number a caller dialed) shows a phone, not a handset. */
  isLine?: boolean;
}

const hasLetters = (value: string) => /\p{L}/u.test(value);

const chipIcon = (label: string, isLine?: boolean) => {
  if (isLine)
    return (
      <span className="grid size-5 shrink-0 place-items-center rounded-full border border-alpha-100 bg-white">
        <HugeiconsIcon
          icon={Call02Icon}
          size={12}
          className="text-content-500"
        />
      </span>
    );
  if (hasLetters(label))
    return <Avatar name={label} size={20} className="text-[8px] font-bold" />;
  return (
    <span className="grid size-5 shrink-0 place-items-center rounded-full bg-alpha-80">
      <HugeiconsIcon
        icon={SmartPhone01Icon}
        size={12}
        className="text-content-500"
      />
    </span>
  );
};

export const AddressChip = ({
  address,
  name,
  tinted,
  isLine
}: AddressChipProps) => {
  const label = name || address;

  return (
    <span
      className={cx(
        "flex min-w-0 shrink items-center gap-2 rounded-[50px] border border-dashed border-alpha-100 py-1.5 pl-1.5 pr-2",
        tinted ? "bg-primary-50" : "bg-alpha-40"
      )}
    >
      {chipIcon(label, isLine)}
      <span className="truncate text-xs font-medium text-content-1000">
        {address}
      </span>
    </span>
  );
};
